// realtime で使うモデル ID。**この 1 行のためだけにファイルを分けている。**
//
// `functions/api/realtime/token.ts` がこれを import するため、このファイルは
// `tsconfig.functions.json` (DOM の型が無いプロジェクト) からも型検査される。
// engine.ts に置くと、そこにある `window` を触る関数 (resolveEngine) が
// `Cannot find name 'window'` で落ちる — connectivityVerdict.ts を
// connectivityStore.ts から分けたのと同じ構造的な制約 (2026-08-23)。
//
// **非秘密の設定はコード定数で持つ** (dashboard の env var に置かない方針)。
// ここを単一ソースにして token の発行と session.started の両方が読む。
// 二重に書くと、ログ上のモデルと実際に喋ったモデルが食い違っても気づけない。
//
// 2.1 を選ぶ根拠は実測: 氏名 16/30 → 18/30、価格は gpt-realtime-2 と同額
// (docs/measurements/2026-08-29-realtime-v2-spike.md の結果 7)。
export const REALTIME_MODEL = "gpt-realtime-2.1";

/**
 * realtime に喋らせる声。**既定任せにしない** — 上流が既定を変えた日に黙って声が変わり、
 * しかも選び直した記録がどこにも残らない。
 *
 * 事前チェックの案内もモデルに読ませる — 2026-09-02 に一度 cascade と同じ事前生成 mp3 で
 * 鳴らしたが、案内 (ElevenLabs `qbfQuoRJv1T3ei3qV4bc`) と氏名のやり取り (ここの声) が交互に
 * 鳴るので撤回した (spec 2026-08-29 D18)。**realtime API は ElevenLabs の声を出せない**ので、
 * cascade と同じ声にすることは構造的にできない。live もこの名前を使うが、**モデルが違うので
 * 同じ声には聞こえない** (liveModel.ts の LIVE_VOICE)。
 *
 * 聴き比べ: `uv run docs/research/realtime-v2/build-listen-page.py` →
 * `open docs/research/realtime-v2/data/listen.html` (先頭行が現行の cascade)。
 * **まだ選定していないので上流の既定 `marin` を明示しているだけ**。
 */
export const REALTIME_VOICE = "marin";
